const actions = {
    FETCH_FORWARDS: 'FETCH_FORWARDS',
    FETCH_FORWARD: 'FETCH_FORWARD',
    RESET_FORWARD: 'RESET_FORWARD',

    fetchForwardsAction: (data) => {
        return {
            type: actions.FETCH_FORWARDS,
            data: data
        };
    },
    resetForwardFormAction: () => {
        return {
            type: actions.RESET_FORWARD,
            data: null
        };
    },
    fetchForwardAction: (data) => {
        return {
            type: actions.FETCH_FORWARD,
            data: data
        };
    },
};

export default actions;
